import * as S from './styled'

/**
 * 에러 메시지 컴포넌트
 * @param {Object} errors - 에러 객체 { fieldName: errorMessage }
 * @param {string} name - 표시할 필드명
 * @param {string} [padT] - 상단 패딩
 */
export default function Error({ errors, name, padT, padL }) {
  if (!errors || !errors[name]) return null

  return (
    <S.WarningMsg $padT={padT} $padL={padL}>{errors[name]}</S.WarningMsg>
  )
}
